module.exports = __webpack_public_path__ + "static/img/12.ff4dad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/12.jpg
// module id = N8rF
// module chunks = 1